module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_resort@2x-5cc41e64adaaba7a8727334a6b504d14.webp";